module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm10_illus"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm02_title#title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ranger Escort West of the Pecos Painting by Tom Lea")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01_ch05#part01_ch05fig2"
    }
  }, [_vm._v("The Three Warriors")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch02#part03_ch02fig3"
    }
  }, [_vm._v("‘I was riding a fleet horse …’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part04_ch03#part04_ch03fig4"
    }
  }, [_vm._v("‘The Indians approached the town riding nearly at full speed’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part05_ch01#part05_ch01fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colonel John Coffee Hays.")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part05_ch01#part05_ch01fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The Texan yell so excited the Mexican Infantry that they overshot us’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part06#part06fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Ben McCulloch From a daguerreotype")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part06_ch02#part06_ch02fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ben McCulloch after the Mexican War Courtesy R. D. Mason")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part06_ch03#part06_ch03fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘They swept around the plain under the walls’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part06_ch05#part06_ch05fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Samuel H. Walker")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part06_ch05#part06_ch05fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rangers Enter Mexico City.")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part07_ch03#part06_ch01fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The Rangers used their long rifles with telling effect’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part08_ch01#part08_ch01fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major John S. (Rip) Ford")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part08_ch01#part08_ch01fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The Comanches descended from the hill’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part08_ch02#part08_ch02fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major Robert S. Neighbors. From a daguerreotype")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part08_ch02#part08_ch02fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Removal of the Indians from Texas.")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part09_ch01#part09_ch01fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Juan N. Cortinas")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part09_ch02#part09_ch02fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At La Bolsa From an oil painting")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part10_ch01#part10_ch01fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sam Houston")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part10_ch01#part10_ch01fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lea-Lee-Houston Correspondence.")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part12_ch01#part12_fig01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain L. H. McNelly")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part12_ch02#part12fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Such an unexpected lunge that he went from under my hat’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part13_ch01#part13_fig258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manuel Flores, Son of Juan Flores")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part13_ch02#part13_fig260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bill Callicott, 1875")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part13_ch03#part13_fig264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘And away the five went shooting and yelling’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part13_ch04#part13_fig277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Road to Las Cuevas")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part13_ch04#part13_fig277a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monument to General Juan Flores")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part13_ch04#part13_fig279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Home of Juan Flores")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part13_ch04#part13_fig279a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Corrals of Las Cuevas")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part14_ch02#page_289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Lee Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part14_ch03#page_295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lieutenant John B. Armstrong")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part14_ch03#page_302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Guarded by Rangers, there is no possibility of the prisoner’s escape’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part15_ch01#page_308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major John B. Jones")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part15_ch01#page_310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major John B. Jones’s Commission")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part15_ch02#page_318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The Lieutenant hit the grass near an Indian who had just been dismounted’.")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part15_ch03#page_321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrying Civilization Over the Plains")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part15_ch06#page_336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pink Higgins’s Reply to the Horrell Peace Proposal")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part15_ch06#page_340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pink Higgins and His Men Upon Their Return from a Trip up the Cattle Trail Courtesy of Judge Tom Higgins")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part16_ch02#part16_fig350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don Louis Cardis")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part16_ch02#part16_fig350a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles H. Howard")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part16_ch05#part16_fig362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘When I give the word, fire at my heart—"), _c('em', [_vm._v("Fire!")]), _vm._v("’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part16_ch05#part16_fig364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scenes of the Salt War")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part17_ch01#part17_fig378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain June Peak")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part17_ch01#illus-01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Page of Murphy’s Sworn Statement about the Bass Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part17_ch01#illus-02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One of Several Letters Written by Jim Murphy to Major Jones")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part17_ch01#illus-03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The Rangers came from their hiding and opened fire’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part17_ch01#illus-04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bill from Richard Hart for Cot, Sheet, and Pillow for Sam Bass")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part18_ch01#illus-05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘… and the Rangers saw the campfires not over a halfmile away’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part18_ch03#illus-06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain G. W. Arrington")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part18_ch03#illus-07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Blizzard March"), _c('br'), _vm._v("   From an oil painting")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part19_ch01#illus-08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ranger Types of 1888")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part19_ch02#illus-09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Company D in Uvalde County: Captain Frank Jones, 1886 or 1887 Ira Aten Collection—Courtesy of J. Evetts Haley")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part19_ch02#illus-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Death of Captain Frank Jones")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part19_ch02#illus-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Texas Rangers at El Paso to Prevent the Fitzsimmons-Maher Prize Fight, February, 1896 Courtesy of Mrs. J. H. Rogers")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part19_ch02#illus-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rangers of the Eighties Courtesy of Mrs. J. H. Rogers")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part20_ch01#illus-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain John R. Hughes, After His Ranger Days Courtesy of General W. W. Sterling")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part20_ch02#illus-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘While the horse was falling, Baker shot the Mexican in the head’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part20_ch02#illus-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain W. J. (Bill) McDonald")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part21_ch02#illus-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mexican Fighting Men of the Border Courtesy of Captain R. W. Aldrich")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part21_ch03#illus-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clemente Vergara")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part21_ch03#illus-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vergara Ranch House")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part21_ch03#illus-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene of the Vergara Kidnaping")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part21_ch03#illus-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘They pointed significantly to an object which lay upon a stretcher’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part21_ch03#illus-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vaquero")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part21_ch04#illus-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bravo")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part22_ch01#illus-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Frank Hamer From a painting")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part22_ch01#illus-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frank Hamer and Bugler in the Llano Country, 1914")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part22_ch01#illus-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘I sure felt good that morning’")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part22_ch01#illus-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Border Agreement")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part22_ch01#illus-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Headlines of Frank Hamer’s Charge Against the Bankers")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part23_ch01#illus-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Tom R. Hickman")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part23_ch01#illus-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General W. W. Sterling")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part23_ch01#illus-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Rio Grande Camp at Night Courtesy of Captain R. W. Aldrich")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part23_ch01#illus-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arch Miller")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part23_ch01#illus-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Bootlegger Pack Train Captured by Captain W. L. Wright’s Rangers")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part23_ch01#illus-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bob Summerall")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part23_ch01#illus-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lee Trimble")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part23_ch01#illus-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four Aces of the Border Courtesy of Captain R. W. Aldrich")])]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part23_ch01#page_565",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("565")]), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5919819a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm10_illus.vue
// module id = 87
// module chunks = 0